import _ from "lodash";
import React from "react";
import UIModal from "UIComponents/UIModal";
import classes from "./SchoolInfo.scss";
import { copyToClipboard } from "Utils";
import { CopyOutlined, CloseOutlined } from "@toddle-edu/ds-icons";
import { connect } from "react-redux";
import { setToastMsg } from "routes/modules/LoginModule";
import FeedListv2 from "AppComponents/FeedListv2";

const SchoolInfo = ({ organization, setToastMsg, onClose }) => {
  const { name, id, curriculumPrograms, isPaid } = organization;

  const paidStatus = isPaid ? "Paid" : "Unpaid";

  const onCopy = code => {
    copyToClipboard(code, () => {
      setToastMsg({
        msg: "toastMsgs:copied_capital",
        type: "success",
      });
    });
  };

  const header = [
    {
      label: "Acronym",
      id: "acronym",
      type: "TEXTCOLUMN",
      style: {
        maxWidth: "280px",
        paddingLeft: "0px",
      },
      isSticky: true,
    },
    {
      label: "Curriculum",
      id: "curriculum",
      type: "TEXTCOLUMN",
    },
    {
      label: "Plan",
      id: "plan",
      type: "CUSTOM",
      style: {
        maxWidth: "200px",
      },
    },
    {
      label: "Platform ID",
      id: "platformId",
      type: "CUSTOM",
    },
    {
      label: "Buddy",
      id: "buddy",
      type: "CUSTOM",
    },
  ];

  const rowData = _.map(curriculumPrograms, curriculumProgram => {
    const {
      acronym,
      type,
      subscriptionPlan: { label },
      buddy,
      platformId,
    } = curriculumProgram;
    const email = _.get(buddy, "email", "");
    return {
      acronym,
      curriculum: type,
      plan: label,
      buddy: email,
      platformId,
    };
  });

  const getCustomComponent = ({ column, columnData }) => {
    switch (column.id) {
      case "plan":
      case "platformId":
      case "buddy": {
        return (
          <div className={classes.customCellContainer}>
            <div className={classes.cellTitle}>{columnData}</div>
            <CopyOutlined variant="subtle" onClick={() => onCopy(columnData)} />
          </div>
        );
      }
    }
  };

  return (
    <UIModal isOpen={true} modalContent={classes.modalContent}>
      <div className={classes.container}>
        <div className={classes.header}>
          <div className={classes.leftHeader}>
            <div
              className={classes.titleText}
            >{`${name} - (${paidStatus})`}</div>
            <div className={classes.subTextContainer}>
              <div className={classes.subText}>ID: {id}</div>
              <CopyOutlined variant="subtle" onClick={() => onCopy(id)} />
            </div>
          </div>
          <div className={classes.rightHeader}>
            <CloseOutlined variant="subtle" onClick={onClose} />
          </div>
        </div>
        <div className={classes.innerContainer}>
          <div className={classes.curriculumText}>{`Programmes (${_.size(
            curriculumPrograms
          )})`}</div>
          <div className={classes.tableContainer}>
            <FeedListv2
              columnList={header}
              feedData={rowData}
              getCustomComponent={getCustomComponent}
            />
          </div>
        </div>
      </div>
    </UIModal>
  );
};

const mapActionCreators = {
  setToastMsg,
};

export default connect(null, mapActionCreators)(SchoolInfo);
